/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { Utility } from '@/utils/TimeUtils'
import { base } from '@/base/base'
import { MsgIDs } from '@/defines/MsgIDs'
import { PopupViews } from '@/defines/EnumDefine'
import { wsClient } from '@/net/WebSocketClient'

export enum boxStatus {
  none = 1, //没数据
  notBox = 2, //没点击礼盒
  clickBox = 3, //点击过礼盒
}

export class PinDuoModule extends ModuleBase {
  public isFirstStatus = boxStatus.none
  public boxGiftGold = ['0', '0', '0', '0'] //礼盒实际获得金币
  public maxBoxGiftGold = 0
  public playerInfo: any = null
  public turnList: any[] = []
  public RunWinMoney = 0 //转盘中奖金额
  public winRecordList: any[] = [] //
  public Turn3playid = 0
  public GiftGold_Pot = '0'
  public showView = false

  public timePanel: any = null

  public spinClick = false //拼多多转盘点击限制（点击后要先置灰）
  init(): void {
    this.isFirstStatus = boxStatus.none
    this.boxGiftGold = ['0', '0', '0', '0']
    this.playerInfo = null
    this.turnList = []
    this.showView = false
    this.maxBoxGiftGold = 0
    this.Turn3playid = 0
    this.GiftGold_Pot = '0'
  }

  onClear(): void {
    this.boxGiftGold = ['0', '0', '0', '0']
    this.isFirstStatus = boxStatus.none
    this.playerInfo = null
    this.turnList = []
    this.showView = false
    this.Turn3playid = 0
    this.maxBoxGiftGold = 0
    this.GiftGold_Pot = '0'
    if (hall.pinDuoModule.timePanel) {
      Utility.cancelTimer(hall.pinDuoModule.timePanel)
    }
    hall.pinDuoModule.timePanel = null
  }

  onLoad(): void {}

  onDestroy(): void {}

  inits2c(): void {
    //需要判断海报弹窗的，所以开局要去请求状态，如果状态为已经开礼包了就要显示海报的
    ;(hall.s2c as any)['onClientTurn3GiftAck'] = function (msg: any) {
      // uint32 UserID = 1;
      // uint32 GiftType = 2;   // 0:未领取礼包,1:已经领取礼包
      // repeated string GiftGold = 3;  // 礼包金额
      // string  GiftGold_Pot = 4;  // 礼包金额上限
      // uint32 Turn3playid = 5; // 剧本ID

      hall.pinDuoModule.isFirstStatus = msg.GiftType == 0 ? boxStatus.notBox : boxStatus.clickBox
      hall.pinDuoModule.boxGiftGold = msg.GiftGold
      hall.pinDuoModule.Turn3playid = msg.Turn3playid
      hall.pinDuoModule.GiftGold_Pot = msg.GiftGold_Pot
      hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新pdd红点
      if (hall.pinDuoModule.showView) {
        if (hall.pinDuoModule.timePanel) {
          base.uiHudSystem.hide('SystemWaitingCopy')
          Utility.cancelTimer(hall.pinDuoModule.timePanel)
          hall.pinDuoModule.timePanel = null
        }
        hall.pinDuoModule.showPinView()
      } else if (hall.pinDuoModule.isFirstStatus == boxStatus.clickBox) {
        hall.pinDuoModule.postPddPlayData()
      }
    }

    ;(hall.s2c as any)['onClientTurn3PlayDataAck'] = function (msg: any) {
      //       uint32 UserID = 1;
      // string strGiftGold = 2; // 礼包总金额
      // string strGiftLimit = 3; // 礼包上限金额
      // uint32 TurnNum = 4; // 转盘次数
      // bool   BGet = 5; // 是否可以领取礼包
      // uint64 NowTime = 6; // 当前时间
      // uint64 EndTime = 7; // 活动结束时间
      // repeated Turn3CellGold Turn3Cell = 8; //格子金额区间
      // repeated Turn3GetGoldData Turn3Data = 9; // SPIN Record
      hall.pinDuoModule.playerInfo = {
        strGiftGold: msg.strGiftGold,
        strGiftLimit: msg.strGiftLimit,
        TurnNum: msg.TurnNum,
        BGet: msg.BGet,
        NowTime: msg.NowTime,
        EndTime: msg.EndTime,
        Turn3Cell: msg.Turn3Cell,
        Turn3Data: msg.Turn3Data,
      }
      hall.eventDispatcher.emit(hall.EventDefine.PddChangPlayerData)
      hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新pdd红点
    }

    ;(hall.s2c as any)['onClientTurn3SpinAck'] = function (msg: any) {
      //uint32 UserID = 1;
      //string strGiftLimit = 2; // 礼包上限金额
      //string strNowGiftGold = 3; // 玩家当前礼包金额
      //string strPlayGiftGold = 4; // 剧本礼包金额

      let strPlayGiftGold = Number(msg.strPlayGiftGold)
      const strNowGiftGold = Number(msg.strNowGiftGold)
      const strGiftLimit = Number(msg.strGiftLimit)
      if (strPlayGiftGold > strGiftLimit) {
        strPlayGiftGold = strGiftLimit
      }
      const addMoney = strPlayGiftGold - strNowGiftGold
      hall.pinDuoModule.changeTurnList(addMoney.toFixed(2))
      hall.pinDuoModule.RunWinMoney = parseFloat(addMoney.toFixed(2)) //保留俩位小数
      hall.eventDispatcher.emit(hall.EventDefine.PddSpinWinChange)
    }

    ;(hall.s2c as any)['onClientTurn3PrizeAck'] = function (_msg: any) {
      //         uint32 UserID = 1;
      //string UserGold = 2;        // 玩家总金币
      //string UserDeposit = 3;     // 充值
      //string UserWithdraw = 4;    // 可提现
      //string UserBonus = 5;       // 赠金
      base.uiHudSystem.hide('SystemWaitingCopy')
      hall.userModule.sendClient2ProxyReqGetBalance()
      hall.eventDispatcher.emit(hall.EventDefine.PddPrizeChange)
    }

    ;(hall.s2c as any)['onClientTurn3WinRecordAck'] = function (msg: any) {
      //uint32 UserID = 1;
      //repeated Turn3GetWinRecordData Turn3WinRecordData = 2;
      hall.pinDuoModule.winRecordList = msg.Turn3WinRecordData
      hall.eventDispatcher.emit(hall.EventDefine.PddWinRecordChange)
    }

    ;(hall.s2c as any)['onClientTurn3GiftGetReq'] = function (_msg: any) {
      hall.eventDispatcher.emit(hall.EventDefine.PddGiftGetChange)
    }
  }

  showPinView() {
    base.uiHudSystem.show('PinDuoPanel') //拼多多界面都是从这里打开
  }

  //前端请求转盘3礼包状态
  postPddStatus(isShow: boolean): void {
    // if (!wsClient.isConnected()) {
    //     wsClient.connect();
    // }
    if (isShow && hall.pinDuoModule.timePanel == null) {
      // 当前是点了没反应，要等几秒才会加载。
      // 修改为：
      // 正常：点了转菊花，有数据时再进入页面。
      // 异常：若转菊花超过10s，或者没有数据返回，停止转菊花Toast提示“Data error”

      base.uiHudSystem.show('SystemWaitingCopy', hall.Language.Loggings)
      const err = function () {
        base.toast(hall.Language.panelShowErroe)
        base.uiHudSystem.hide('SystemWaitingCopy')
        if (hall.pinDuoModule.timePanel) {
          Utility.cancelTimer(hall.pinDuoModule.timePanel)
        }
        hall.pinDuoModule.timePanel = null
      }

      hall.pinDuoModule.timePanel = Utility.scheduleOnce(err, 10)
    }
    const msg = {
      UserID: hall.userModule.userId,
    }
    this.showView = isShow
    wsClient.send(MsgIDs.ClientTurn3GiftReq, msg)
  }

  //前端请求转盘3
  postPddPlayData(): void {
    //  if (!wsClient.isConnected()) {
    //     wsClient.connect();
    // }
    const msg = {
      UserID: hall.userModule.userId,
    }
    wsClient.send(MsgIDs.ClientTurn3PlayDataReq, msg)
  }

  //前端请求转盘3旋转
  postPddSpin(): void {
    const msg = {
      UserID: hall.userModule.userId,
    }
    wsClient.send(MsgIDs.ClientTurn3SpinReq, msg)
  }

  //前端请求转盘3礼包领取
  postPddPrize(): void {
    const msg = {
      UserID: hall.userModule.userId,
      ChannelID: base.channelId,
    }
    wsClient.send(MsgIDs.ClientTurn3PrizeReq, msg)
  }

  //前端请求转盘3WinRecord数据
  postWinRecord(): void {
    const msg = {
      UserID: hall.userModule.userId,
    }
    wsClient.send(MsgIDs.ClientTurn3WinRecordReq, msg)
  }

  //前端请求转盘3礼包状态领取
  postGetReq(): void {
    const msg = {
      UserID: hall.userModule.userId,
      GiftGold: hall.pinDuoModule.maxBoxGiftGold,
      Turn3playid: hall.pinDuoModule.Turn3playid,
    }
    wsClient.send(MsgIDs.ClientTurn3GiftGetReq, msg)
  }

  onPreloadData(): void {
    this.postPddStatus(false)
  }

  setPlayerData(data: any) {
    this.playerInfo = data
  }

  getPlayerData() {
    return this.playerInfo
  }

  //模拟假信息
  initTurnList() {
    const name = this.generateGuestIds()
    //this.turnList = [
    //    { nickname: name[0], type: 1 },
    //    { nickname: name[1], type: 2 },
    //    { nickname: name[2], type: 1 },
    //    { nickname: name[3], type: 2 },
    //]
    for (let i = 0; i < 50; i++) {
      const data = { nickname: name[i], money: 2000 }
      this.turnList.push(data)
    }
    this.turnList.sort(() => Math.random() - 0.5)
  }

  generateGuestIds(): string[] {
    const guestIds: string[] = []
    for (let i = 0; i < 50; i++) {
      // 生成0-9999的随机数
      const randomNum = Math.floor(Math.random() * 10000)
      // 转换为4位字符串，不足补零
      const numStr = randomNum.toString().padStart(4, '0')
      // 隐藏前两位
      const hiddenId = `Guest**${numStr.substring(2)}`
      guestIds.push(hiddenId)
    }
    return guestIds
  }

  getTurnList() {
    return this.turnList
  }

  maskUsername = (username: string) => {
    const guestPos = username.indexOf('Guest')
    if (guestPos === -1) return username
    return username.slice(0, guestPos + 5) + '**' + username.slice(guestPos + 7)
  }

  changeTurnList(money: any) {
    //添加玩家奖励
    const nameData = this.maskUsername(hall.userModule.userName)
    const data = { nickname: nameData, money: money }
    this.turnList[0] = data
    this.turnList.sort(() => Math.random() - 0.5)
    hall.eventDispatcher.emit(hall.EventDefine.PddChangTipsChange)
  }

  isShowPddRed() {
    if (this.isFirstStatus == boxStatus.clickBox && this.playerInfo != null) {
      //有数据
      if (this.playerInfo.BGet || this.playerInfo.TurnNum > 0) {
        return true
      }
    }
    return false
  }

  // 是否需要弹窗
  popupView() {
    if (
      this.isFirstStatus == boxStatus.clickBox &&
      this.playerInfo != null &&
      this.playerInfo.BGet
    ) {
      //有数据
      hall.popupViewModule.addPopupView(PopupViews.PinDuoPopPanel)
    }
  }

  popupOpenView() {
    hall.popupViewModule.addPopupView(PopupViews.PinDuoShowPopPanel)
  }
}
